import React, { useContext, useEffect, useState } from 'react';
import { GlobalStateContext } from './GlobalStateContext';
import GraphSelector from '../components/AveragesGraphSelect';
import { Link } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { db } from '../firebase';
import { getDocs } from 'firebase/firestore';
import { collection } from 'firebase/firestore';



const PelletTech = () => {
     const {
        feedlots,
        handleFeedlotSelect,
        selectedFeedlot
    } = useContext(GlobalStateContext);

    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [systems, setSystems] = useState([])




    //probs extract to globalContext once done
    useEffect(() => {
      const fetchSystems = async () => {

        


        if (selectedFeedlot && selectedFeedlot.PelletID) {
          let pelletId = selectedFeedlot.PelletID


         
            const ref = collection(db, pelletId)


            const snapshot = await getDocs(ref);

            const docsArray = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
            }));


            setSystems(docsArray)            

          
        }
        if (selectedFeedlot?.PelletID === "4001") {
          setCombinedFieldOptions([
            { value: 'LSCTankLevel', label: 'LSC Vol (Gal)', source: 'pelletTech' },
            { value: 'totalLSC', label: 'Total LSC (Gal)', source: 'pelletTech' },
            { value: 'totalGarlic', label: 'Total SarStart (Gal)', source: 'pelletTech' },
            { value: 'garlicTankLevel', label: 'SarStart Tank Level (Gal)', source: 'pelletTech'}
          ]);
        } else {
          setCombinedFieldOptions([
            { value: 'LSCTankLevel', label: 'LSC Vol (Gal)', source: 'pelletTech' },
            { value: 'totalLSC', label: 'Total LSC (Gal)', source: 'pelletTech' },
            { value: 'totalGarlic', label: 'Total Garlic (Gal)', source: 'pelletTech' },
            { value: 'garlicTankLevel', label: 'Garlic Tank Level (Gal)', source: 'pelletTech'}
          ]);
        }
        



      }

      fetchSystems()
    }, [selectedFeedlot])

    


    const [systemIndex, setSystemIndex] = useState(null)

    // Combined field options for both datasets
    const [combinedFieldOptions, setCombinedFieldOptions] = useState([
      { value: 'LSCTankLevel', label: 'LSC Vol (Gal)', source: 'pelletTech' },
      { value: 'totalLSC', label: 'Total LSC (Gal)', source: 'pelletTech' },
      { value: 'totalGarlic', label: 'Total Garlic (Gal)', source: 'pelletTech' },
      { value: 'garlicTankLevel', label: 'Garlic Tank Level (Gal)', source: 'pelletTech'}
    ]);


    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-900 h-max p-3">
            {/* Welcome Section */}
            <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-#2f4858 to-#33658a p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold mb-2 lg:mb-0">Pellet Optimizer Dashboard</h1>
                        <p className="text-lg">Explore detailed graphs and historical data for each component.</p>
                    </div>
                     <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
                     <Link to="/about">
      <button className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
        Learn More
      </button>
    </Link>
                    </div>
                </div>
            </div>

           
                  <div className="col-span-2 md:col-span-1 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10 flex flex-col items-center">        
                    <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Date Range:</h2>
                    
                    {/* From Date Picker */}
                    <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
                        <DatePicker
                        selected={selectedFromDate} 
                        onChange={date => setSelectedFromDate(date)}
                        selectsStart
                        startDate={selectedFromDate}
                        endDate={selectedToDate}
                        dateFormat="yyyy/MM/dd"
                        placeholderText="From: yyyy/mm/dd"
                        className="bg-transparent outline-none w-full"
                        />
                    </label>

                    {/* To Date Picker */}
                    <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
                        <DatePicker
                        selected={selectedToDate} 
                        onChange={date => setSelectedToDate(date)}
                        selectsEnd
                        startDate={selectedFromDate}
                        endDate={selectedToDate}
                        minDate={selectedFromDate} // Prevents selecting a "to" date earlier than "from"
                        dateFormat="yyyy/MM/dd"
                        placeholderText="To: yyyy/mm/dd"
                        className="bg-transparent outline-none w-full"
                        />
                    </label>
                    </div>
            
                  {/* Feedlot Selection */}
                  {feedlots.length > 0 && (
                    <div className="col-span-2 lg:col-span-3 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
                      <h2 className="text-xl font-semibold text-gray-100 m-2">Select a Feedlot:</h2>
                      <select
                        className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md"
                        onChange={handleFeedlotSelect}
                        value={selectedFeedlot ? feedlots.findIndex(feedlot => (feedlot.SarCompID === selectedFeedlot.SarCompID && feedlot.TMRID === selectedFeedlot.TMRID && feedlot.PelletID === selectedFeedlot.PelletID)) : ''}
                      >
                        <option value="">-- Select a Feedlot --</option>
                        {feedlots.map((feedlot, index) => (
                          <option key={index} value={index}>
                            {feedlot.Name || `Feedlot ${index + 1}`}
                          </option>
                        ))}
                      </select>

                      {selectedFeedlot && selectedFeedlot.PelletID && 
                        <div>
                          <h2 className="text-xl font-semibold text-gray-100 m-2">Select a System:</h2>

                            <select
                            className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md"
                            onChange={(e) => setSystemIndex(e.target.value)}
                            value={systemIndex}
                            >
                            <option value="">-- Select a System --</option>
                            {systems.map((system, index) => (
                              <option key={index} value={index}>
                                {system.Name || `System ${index + 1}`}
                              </option>
                            ))}
                          </select>     
                        </div>
                                         
                      }

                      
                    </div>
                  )}

            {/* Weekly Average Data Selection */}
            <div className='col-span-2 lg:col-span-4 bg-slate-400  p-4 rounded-lg shadow-3xl'>
                <div className=''>
                    <GraphSelector selectedFromDate={selectedFromDate} 
                    selectedToDate={selectedToDate}
                    combinedFieldOptions={combinedFieldOptions}
                    systemIndex={systemIndex}
                    systems={systems}/>
                </div>
            </div>
        </div>
    );
}

export default PelletTech